const { stripe } = require(`./../apijsons/messages/error/stripe/errors`);
const { payu } = require(`./../apijsons/messages/error/payu/errors`);
const { countries } = require(`./../countries`);

export default {
    en: {
        message: {
            payment_info: 'Payment Information',
            payment_methods: 'Payment Method',
            scantopay: 'Scan to pay',
            creditcard: 'Credit Card',
            wechat: 'WeChat Pay',
            alipay: 'Alipay',
            OXXO: "OXXO",
            SEVEN_ELEVEN: "SEVEN ELEVEN",
            OTHERS_CASH_MX: "OTHERS CASH PAYMENT",
            generate_receipt: "Generate receipt",
            card: "Use a different card",
            other_payment: "Other Payments",
            waitingPayment: 'Waiting for payment authorization',
            full_name: 'Full name',
            phone: 'Phone',
            email: 'Email',
            address: 'Address',
            city: 'City',
            zip: 'Zip',
            country: 'Country',
            number: 'Number',
            security_code: 'Security code',
            expiration_date: 'Expiration date',
            continue: 'Continue',
            back: 'Back',
            retry: 'Retry',
            use_another_card: 'Use another card',
            add_card: "Add card",
            pay: 'Pay',
            add_payment_method: 'Add Payment Method',
            payment_method: 'Payment submit',
            try_again: 'Try Again',
            choose: 'or choose one of the following',
            contact_bank: 'Try calling your bank to authorize the charge and click "try again"',
            cancel: 'Cancel',
            error_msg: 'Oops... Something went wrong!',
            success_title: ' Activation Succeded !',
            success_msg: 'Thank you and welcome %{fullName}, You will receive a confirmation email and receipt for your transaction in your registered account..',
            close: 'Close',
            invalid_api: 'The API can not communicate with our payment processor because the key is invalid. Please contact the website owner or customerservice@mytravelbenefits.club.',
            stand_by: 'Please stand by',
            expired_payment: 'Expired Payment',
            expired_msg: 'Remember that you must specify the payment within <b> %{valueExpire} hs</b> after purchase. Otherwise, your purchase request will be canceled.',
            stripe,
            payu,
            countries,
        },
    },
    es: {
        message: {
            payment_info: 'Información del pago',
            payment_methods: 'Metodo de Pago',
            scantopay: 'Escanear para pagar',
            creditcard: 'Tarjeta de crédito',
            wechat: 'WeChat Pay',
            alipay: 'Alipay',
            OXXO: "OXXO",
            SEVEN_ELEVEN: "SEVEN ELEVEN",
            OTHERS_CASH_MX: "OTROS PAGOS EN EFECTIVO",
            generate_receipt: "Generar Comprobante",
            card: "Usa una tarjeta diferente",
            other_payment: "Otros Sistemas de Pagos",
            waitingPayment: 'Esperando autorizacion de pago',
            full_name: 'Nombre completo',
            phone: 'Teléfono',
            email: 'Correo electrónico',
            address: 'Dirección',
            city: 'Ciudad',
            zip: 'Código postal',
            country: 'País',
            number: 'Número',
            security_code: 'Código de seguridad',
            expiration_date: 'Fecha de expiración',
            continue: 'Continuar',
            back: 'Regresar',
            retry: 'Reintentar',
            use_another_card: 'Usar otra tarjeta',
            add_card: "Agregar Tarjeta",
            pay: 'Pagar',
            add_payment_method: 'Agregar método de pago',
            payment_method: 'Enviar pago',
            try_again: 'Intente de nuevo',
            choose: 'o elija una de las siguientes opciones',
            contact_bank: 'Intente llamar a su banco para autorizar el cargo y presione "Intentar de nuevo"',
            cancel: 'Cancelar',
            error_msg: 'Ups... Algo salio mal',
            success_title: '¡ Activación Exitosa !',
            success_msg: 'Gracias y Bienvenido %{fullName}, Recibirás un correo de confirmación y un recibo por tu transacción en tu cuenta registrada..',
            close: 'Cerrar',
            invalid_api: 'El API no puede comunicarse con nuestro procesador de pagos por que la llave es invalida. Por favor contate al dueño del sitio o envie un email a customerservice@mytravelbenefits.club.',
            stand_by: 'Por favor espere',
            expired_payment: 'Pago Expirado',
            expired_msg: 'Recuerda que debes concretar el pago dentro de las <b> %{valueExpire} hs</b> posteriores a comprar. De lo contrario, tu solicitud de compra será cancelada.',
            stripe,
            payu,
            countries,
        },
    },
    pt_BR: {
        message: {
            payment_info: 'Informações de pagamento',
            creditcard: 'Cartão de crédito',
            full_name: 'Nome completo',
            phone: 'Telefone',
            email: 'Correio eletrônico',
            address: 'Endereço',
            city: 'Cidade',
            zip: 'Código postal',
            country: 'Country',
            number: 'Número',
            security_code: 'Código de segurança',
            expiration_date: 'Data de expiração',
            continue: 'Continue',
            back: 'Retorno',
            retry: 'Tente novamente',
            use_another_card: 'Use outro cartão',
            add_card: "Adicionar cartão",
            pay: 'Pagar',
            add_payment_method: 'Agregar metodo de pago',
            payment_method: 'Enviar pagamento',
            try_again: 'Tente novamente',
            choose: 'ou escolha uma das seguintes opções',
            contact_bank: 'Tente ligar para seu banco para autorizar a cobrança e pressione "Tentar novamente"',
            cancel: 'Cancelar',
            error_msg: 'Ups ... Algo deu errado',
            success_title: '¡ Ativação bem sucedida !',
            success_msg: 'Obrigado e bem vindo %{fullName}, Você receberá um email de confirmação e um recibo da sua transação em sua conta registrada..',
            close: 'Fechar',
            invalid_api: 'A API não pode se comunicar com nosso processador de pagamento porque a chave é inválida. Entre em contato com o proprietário do site ou envie um email para customerservice@mytravelbenefits.club.',
            stand_by: 'Por favor espere',
            stripe,
            payu,
            countries,
        },
    },
    zh: {
        message: {
            payment_info: 'Payment Information',
            payment_methods: 'Payment Method',
            scantopay: 'Scan to pay',
            creditcard: 'Credit Card',
            wechat: 'WeChat Pay',
            alipay: 'Alipay',
            OXXO: "OXXO",
            SEVEN_ELEVEN: "SEVEN ELEVEN",
            OTHERS_CASH_MX: "OTHERS CASH PAYMENT",
            generate_receipt: "Generate receipt",
            card: "Use a different card",
            other_payment: "Other Payments",
            waitingPayment: 'Waiting for payment authorization',
            full_name: 'Full name',
            phone: 'Phone',
            email: 'Email',
            address: 'Address',
            city: 'City',
            zip: 'Zip',
            country: 'Country',
            number: 'Number',
            security_code: 'Security code',
            expiration_date: 'Expiration date',
            continue: 'Continue',
            back: 'Back',
            retry: 'Retry',
            use_another_card: 'Use another card',
            add_card: "Add card",
            pay: 'Pay',
            add_payment_method: 'Add Payment Method',
            payment_method: 'Payment submit',
            try_again: 'Try Again',
            choose: 'or choose one of the following',
            contact_bank: 'Try calling your bank to authorize the charge and click "try again"',
            cancel: 'Cancel',
            error_msg: 'Oops... Something went wrong!',
            success_title: ' Activation Succeded !',
            success_msg: 'Thank you and welcome %{fullName}, You will receive a confirmation email and receipt for your transaction in your registered account..',
            close: 'Close',
            invalid_api: 'The API can not communicate with our payment processor because the key is invalid. Please contact the website owner or customerservice@mytravelbenefits.club.',
            stand_by: 'Please stand by',
            expired_payment: 'Expired Payment',
            expired_msg: 'Remember that you must specify the payment within <b> %{valueExpire} hs</b> after purchase. Otherwise, your purchase request will be canceled.',
            stripe,
            payu,
            countries,
        },
    },
};